import { scopedProjectKey } from "@afar-research/client-runtime/environment";
import type { ScopedProjectRef } from "@afar-research/contracts";
import { getClientSettings, useClientSettings } from "./hooks/useSettings";
export function useProjectIcon(projectRef: ScopedProjectRef | null) {
  const key = projectRef ? scopedProjectKey(projectRef) : null;
  return useClientSettings((settings) =>
    key ? settings.projectPresentation?.[key]?.icon : undefined,
  );
}

export function getProjectWorkspacePreference(projectRef: ScopedProjectRef) {
  return getClientSettings().projectPresentation?.[scopedProjectKey(projectRef)]?.workspace;
}

import { useUpdateClientSettings } from "./hooks/useSettings";
export function useUpdateProjectPresentation() {
  const update = useUpdateClientSettings();
  return (
    members: readonly ScopedProjectRef[],
    patch: { icon?: string | null; workspace?: "local" | "worktree" | null },
  ) => {
    const next = { ...getClientSettings().projectPresentation };
    for (const member of members) {
      const key = scopedProjectKey(member);
      const value = { ...next[key] };
      if (patch.icon !== undefined) {
        if (patch.icon === null) delete value.icon;
        else value.icon = patch.icon;
      }
      if (patch.workspace !== undefined) {
        if (patch.workspace === null) delete value.workspace;
        else value.workspace = patch.workspace;
      }
      next[key] = value;
    }
    update({ projectPresentation: next });
  };
}
